import { useState } from "react";
import { LiveEvent } from "../hooks/useLiveActivity";

interface Props {
  events: LiveEvent[];
}

function formatTime(seconds: number): string {
  if (seconds < 5) return "just now";
  if (seconds < 60) return `${seconds}s ago`;
  const mins = Math.floor(seconds / 60);
  return `${mins}m ago`;
}

export default function LiveFeed({ events }: Props) {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className={`live-feed ${collapsed ? "live-feed-collapsed" : ""}`}>
      <div className="live-feed-header">
        <span className="live-feed-label">— Live</span>
        <button
          className="live-feed-toggle"
          onClick={() => setCollapsed((prev) => !prev)}
        >
          {collapsed ? "Show" : "Hide"}
        </button>
      </div>

      {!collapsed && (
        <div className="live-feed-list">
          {events.map((event, index) => (
            <div
              key={event.id}
              className={`feed-event ${index === 0 ? "feed-event-new" : ""}`}
            >
              <div className="feed-event-top">
                <span className="feed-username">{event.username}</span>
                <span className="feed-time">{formatTime(event.secondsAgo)}</span>
              </div>
              <div className="feed-event-bottom">
                <span className="feed-location">
                  {event.city}, {event.country}
                </span>
                <span
                  className={`feed-suspect ${
                    event.correct ? "feed-suspect-correct" : "feed-suspect-wrong"
                  }`}
                >
                  → {event.suspect}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
